import { render, staticRenderFns } from "./WorkDocsDocumentTypeTable.vue?vue&type=template&id=93ac45ac&"
import script from "./WorkDocsDocumentTypeTable.vue?vue&type=script&lang=js&"
export * from "./WorkDocsDocumentTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports